import { Component, AfterViewInit } from '@angular/core';
//import { AngularFire, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2';
import * as firebase from 'firebase';
import { MemberService } from './member.service';
import {DomSanitizer,SafeResourceUrl,} from '@angular/platform-browser';

import { Member } from './member';
declare var jQuery:any;

@Component({
  selector: 'member-spritjoy',
  templateUrl: './spritjoy.component.html'
})

export class SpritJoyComponent {
	//profileData: FirebaseObjectObservable<any>;
	//memberProfile = new Member();
	warningMsg = '';
	currUserUid = '';
	dayNum:number;
	totalDay;
	joyRec;
	lastRec = 0;
	recToShow = 0;
	today = new Date().getTime();
	memberProfile;
	public s3DayParams = {
		Bucket: 'cefkid-spritjoy',
		Delimiter: '/'
	};

	dayTitle = [
		"第1天 - 神創造天地","第2天 - 神是甚麼樣子的？","第3天 - 三位一體","第4天 - 神永不改變","第5天 - 聖潔的神","第6天 - 代我們受責罰","第7天 - 忘記了？","第8天 - 神知道","第9天 - 神是愛","第10天 - 公義的神","第11天 - 神介意","第12天 - 神寬恕","第13天 - 原諒的心","第14天 - 神必管教","第15天 - 神的愛在我們裏面","第16天 - 全世界都屬於神！","第17天 - 今天神對我說話","第18天 - 神呼召我","第19天 - 神賜下一切","第20天 - 神賜下一切","第21天 - 以神為首！","第22天 - 神應允祈求","第23天 - 神同在","第24天 - 神無所不能","第25天 - 神的保守","第26天 - 我願像天父","第27天 - 天父幫助我","第28天 - 獻給天父","第29天 - 可信靠的神","第30天 - 神的家",
		"第1天 - 「專遞」","第2天 - 直接從天上來","第3天 - 拯救能力","第4天 - 一位憤怒的王","第5天 - 你可以完全倚靠！","第6天 - 那決定了！","第7天 - 大能的話","第8天 - 沒有甚麼值得哭泣的","第9天 - 那是神蹟","第10天 - 黑暗或光明？","第11天 - 沒有其他方法","第12天 - 祂掌管著一切","第13天 - 你會答應嗎？","第14天 - 預告未來","第15天 - 祂已經來了","第16天 - 成了","第17天 - 一位意外的客人成了","第18天 - 祂正來了！","第19天 - 不是欺騙！","第20天 - 撒但的謊言","第21天 - 厲害！尖銳！刺透！","第22天 - 從言語來的亮光","第23天 - 真的自由！","第24天 - 注意！","第25天 - 為神長進","第26天 - 如何可以有智慧","第27天 - 歡笑吧！","第28天 - 變得好像耶穌","第29天 - 值得驕傲的事！","第30天 - 神的地圖",
		"第1天 - 祂真可愛","第2天 - 未有世界以先","第3天 - 大事不好","第4天 - 奇妙的嬰孩","第5天 - 無人像祂","第6天 - 知道祂是誰","第7天 - 你像耶穌嗎？","第8天 - 耶穌哭了？","第9天 - 祂明白你","第10天 - 跟從祂","第11天 - 我真愛祂","第12天 - 所有的小孩","第13天 - 最大的禮物","第14天 - 死亡的代價","第15天 - 好信息","第16天 - 真朋友","第17天 - 毛蟲與你","第18天 - 我們要再見祂","第19天 - 祂聽得見","第20天 - 祂是誰？","第21天 - 祂辦得到？","第22天 - 你獻上甚麼？","第23天 - 螞蟻，安得烈和你","第24天 - 耶穌的朋友","第25天 - 媽媽我愛你","第26天 - 小事做起","第27天 - 充滿喜樂","第28天 - 神的帶領","第29天 - 你的面貌","第30天 - 我愛主耶穌",
		"第1天 - 你不能躲起來","第2天 - 我們小小的光","第3天 - 三件重要事情","第4天 - 可是，我憎恨他！","第5天 - 固執是好或不好？","第6天 - 坐下聆聽","第7天 - 誰是你的領袖？","第8天 - 跟從領袖","第9天 - 承認","第10天 - 甚麼叫做宣教士？","第11天 - 宣教士在那裏？","第12天 - 你又如何？","第13天 - 我不理！","第14天 - 跟我來","第15天 - 邀請你的朋友","第16天 - 改變了的臉孔！","第17天 - 他服從","第18天 - 神揀選你","第19天 - 神有一份獎賞","第20天 - 互相傳染！","第21天 - 服從很困難","第22天 - 我可以給甚麼？","第23天 - 最大的光榮","第24天 - 堅強的性格","第25天 - 比金錢更好","第26天 - 隨身帶著它！","第27天 - 你應在甚麼時候開始？","第28天 - 希望快樂嗎？","第29天 - 要謝恩","第30天 - 其他人在等待",
		"第1天 - 神如何看罪","第2天 - 神定立規則","第3天 - 總得把它放在一處地方！","第4天 - 有罪抑或無罪","第5天 - 真基督徒","第6天 - 基督徒仍會犯罪嗎？","第7天 - 為甚麼基督徒會犯罪？","第8天 - 你的敵人","第9天 - 你的選擇！","第10天 - 智慧行事！","第11天 - 信心是先決條件！","第12天 - 用那鋒利的武器！","第13天 - 失去甚麼？","第14天 - 失去……彼此相交！","第15天 - 失去……喜樂！","第16天 - 失去……力量！","第17天 - 失去……獎賞！","第18天 - 管教使人得益處！","第19天 - 傷痕","第20天 - 祂為你代求","第21天 - 作戰計劃","第22天 - 留在座位","第23天 - 命令：認罪！","第24天 - 命令：認罪！","第25天 - 命令：放下罪！","第26天 - 命令：努力面前！","第27天 - 命令：有信心！","第28天 - 命令：抵擋！","第29天 - 命令：逃避！","第30天 - 等候時不忘工作！",
		"第1天 - 我最親密的朋友","第2天 - 非常真實！","第3天 - 我心中的房子","第4天 - 心裏快樂","第5天 - 一本奇妙的書","第6天 - 打開神話語的鑰匙","第7天 - 賜給你新生命","第8天 - 女皇的禱告","第9天 - 神的話說明了！","第10天 - 永遠屬祂！","第11天 - 不可讓罪惡留在你心","第12天 - 你需要祂！","第13天 - 印第安酋長獻上自己","第14天 - 我做到了！","第15天 - 活出主來！","第16天 - 那一類的果子？","第17天 - 祂瞭解你","第18天 - 一個自私的聖徒？","第19天 - 永遠屬祂！","第20天 - 怎樣得著勇氣","第21天 - 我會引導你","第22天 - 不再發脾氣！","第23天 - 活在我心中","第24天 - 運用恩賜","第25天 - 聖經情人卡","第26天 - 神使我因它得益處","第27天 - 聖靈的禱告","第28天 - 往上看！往上看！","第29天 - 神的看顧！ ","第30天 - 神的朋友",
		"第1天 - 應允祈求","第2天 - 特別送給神的兒女","第3天 - 倚靠主耶穌","第4天 - 神甚麼都知道？","第5天 - 罪使天父不回答禱告","第6天 - 神喜悅的禱告","第7天 - 如果你原諒別人","第8天 - 快樂的人生","第9天 - 不要忘記","第10天 - 我們要求甚麼","第11天 - 耶穌幫助我","第12天 - 只要信！","第13天 - 在祂沒有不成的事","第14天 - 小心禱告","第15天 - 幫助你禱告","第16天 - 禱告的應許","第17天 - 三個答案","第18天 - 不要急","第19天 - 盡你的本分","第20天 - 全心禱告","第21天 - 全家禱告","第22天 - 當盡的責任","第23天 - 感謝天父","第24天 - 神的保守","第25天 - 人人都應該知道","第26天 - 一個禱告的人","第27天 - 為人代求","第28天 - 來得及時","第29天 - 祂賜給我們","第30天 - 耶穌禱告",
		"第1天 - 新生命！","第2天 - 表裡一致！ ","第3天 - 快樂是……","第4天 - 時刻需要！","第5天 - 榮耀的一天！","第6天 - 「哭泣的楊柳」","第7天 - 為別人憂傷","第8天 - 安慰者耶穌","第9天 - 不要抱怨！","第10天 - 等候主","第11天 - 特別的賞賜","第12天 - 天糧","第13天 - 鹿與溪水","第14天 - 又飽又傻的狄比！","第15天 - 絕不可能！","第16天 - 美善是有價值的！","第17天 - 要喜樂","第18天 - 耶穌顯示給我們看了","第19天 - 主這樣說！","第20天 - 循環不！","第21天 - 阿司匹靈","第22天 - 偷去的硬幣","第23天 - 傷心的故事","第24天 - 從天而來的和平使者","第25天 - 給你的使命！ ","第26天 - 家中和平使者","第27天 - 玩耍時的和平使者","第28天 - 你知道是會發生的！","第29天 - 忠心的朋友","第30天 - 快樂日！",
		"第1天 - 神愛祂所造的","第2天 - 神使人有分別","第3天 - 發出強光","第4天 - 士兵","第5天 - 勝出比賽","第6天 - 五隻手指的應許","第7天 - 天上的保鑣","第8天 - 持之以恒","第9天 - 現代的劍","第10天 - 愉快的歌","第11天 - 祂看顧","第12天 - 我是祂的羊","第13天 - 交友之道","第14天 - 助人為快樂之本","第15天 - 快樂的交易","第16天 - 祂看顧麻雀","第17天 - 祂使愁容變歡顏","第18天 - 神愛每一個人","第19天 - 不斷祈求","第20天 - 一流的盔甲","第21天 - 每天都是感恩日","第22天 - 怎樣得到智慧","第23天 - 早晨的力量","第24天 - 要知足","第25天 - 做不可能的事","第26天 - 不！不！不！","第27天 - 擔當重擔","第28天 - 基督徒的武器","第29天 - 完全赦免","第30天 - 凡事都有時",
		"第1天 - 無論何時","第2天 - 親近神","第3天 - 讓神的話進入你心","第4天 - 你如何知道？","第5天 - 學習中成長","第6天 - 感覺安穩","第7天 - 求神幫助","第8天 - 別發愁！","第9天 - 祂顧念你們","第10天 - 不要害怕","第11天 - 凡事都能作！","第12天 - 不要埋怨和爭論","第13天 - 彼此相愛","第14天 - 彼此饒恕","第15天 - 分擔困難","第16天 - 不要憎恨","第17天 - 不要發怒","第18天 - 饒恕他","第19天 - 自制","第20天 - 盡力去瞭解","第21天 - 他比我強","第22天 - 不要說別人的壞話","第23天 - 尊重別人","第24天 - 罪惡的源頭","第25天 - 遵守法律","第26天 - 遵守你的法律","第27天 - 抵擋撒但","第28天 - 逃避魔鬼","第29天 - 告訴神","第30天 - 別人從你的身上看見神",
		"第1天 - 甚麼是見證人？","第2天 - 神的見證人要說些甚麼？","第3天 - 學習作見證","第4天 - 今天開始！","第5天 - 請差遣我！","第6天 - 見證人的助手","第7天 - 全為神！","第8天 - 星星引路","第9天 - 不要作約拿！","第10天 - 相信神","第11天 - 忠心的跟隨者","第12天 你有沒有告訴你的兄弟？","第13天 - 找我們的朋友","第14天 - 向朋友作見證","第15天 - 贏得朋友","第16天 - 幫助主內的朋友","第17天 - 幫助無助者","第18天 - 不要灰心！","第19天 - 神的工人","第20天 - 遵行父的旨意","第21天 - 神的蕃茄","第22天 - 奉獻我們所有的","第23天 - 現在就事奉神","第24天 - 洛爾邀請老師","第25天 - 我們不能閉口不言！","第26天 - 準備回答","第27天 - 以書信作見證","第28天 - 逐戶傳講","第29天 - 趕快！趕快！","第30天 - 各就各位，預備，去！",		
		"第1天 - 暗語是甚麼？","第2天 - 揭開奧祕","第3天 - 大團圓","第4天 - 祂活著","第5天 - 祂必再來","第6天 - 我們要搬家了","第7天 - 預備","第8天 - 與主一起","第9天 - 有很多要作的","第10天 - 直至何時？","第11天 - 如果你順服","第12天 - 怎樣？","第13天 - 信號","第14天 - 我們要復活","第15天 - 太空船","第16天 - 天上的身體","第17天 - 填充","第18天 - 不再死亡","第19天 - 與主同在","第20天 - 交帳","第21天 - 都沒有了","第22天 - 經得起試驗","第23天 - 審判官","第24天 - 冠冕？","第25天 - 你喜樂嗎？","第26天 - 你高興嗎？","第27天 - 作領袖","第28天 - 信靠神","第29天 - 歸還","第30天 - 頒冠冕堂皇的日子嗎？",
	];
	monthTitle = [
		'01 全能的天父',
		'02 神的話真的有能力！',
		'03 耶穌真好',
		'04 耶穌為我們死',
		'05 你真是基督徒嗎？',
		'06 聖靈像鴒子',
		'07 我的禱告',
		'08 蒙福之路',
		'09 不要憂愁神會看顧',
		'10 尋求神的旨意',
		'11 你愛耶穌嗎？',
		'12 主必要來',
	]
	daysOfMonth;
	sectorExpand = [1,1,1,1,1,1,1,1,1,1,1,1];
	//url:SafeResourceUrl;

	constructor(public sanitizer:DomSanitizer, private memberService: MemberService) {
		this.daysOfMonth = Array(30).fill(0).map((x,i)=>i);
		firebase.auth().onAuthStateChanged(user => {
			if (user) {
				this.currUserUid = user.uid;
				//this.currUserUid = 'fVEPM5dJXtffS1XVNLEbRJxFgR92';
				//this.memberService.s3.listObjectsV2(this.s3DayParams, (err, data) => {
				//	if (!err) {
				//		if (data.CommonPrefixes.length) {
				//			this.totalDay = data.CommonPrefixes;
				let db = firebase.database();
				db.ref('profile/'+this.currUserUid).once('value').then(
					(profile:any)=>{
						this.memberProfile = profile.val();
						db.ref('joyRecords/'+this.currUserUid).once('value').then(
							(snapshot:any) => {
								if (snapshot.val()){
									this.joyRec = snapshot.val();
									this.lastRec = this.joyRec.length-1;
									let lastRecDate = new Date(this.joyRec[this.lastRec].created).getTime();
									let now = new Date();
									let nowMonth = now.getMonth()*1+1<10?'0'+(now.getMonth()*1+1):now.getMonth()*1+1;
									let nowDay = now.getDate()<10?'0'+now.getDate():now.getDate();
									let nowVal = parseInt(now.getFullYear()+''+nowMonth+''+nowDay);
									//console.log(now.getFullYear()+''+nowMonth+''+nowDay)
									let recDate = new Date(this.joyRec[this.lastRec].created)
									let recMonth = recDate.getMonth()*1+1<10?'0'+(recDate.getMonth()*1+1):recDate.getMonth()*1+1;
									let recDay = recDate.getDate()<10?'0'+recDate.getDate():recDate.getDate();
									let recVal = parseInt(recDate.getFullYear()+''+recMonth+''+recDay)
									//console.log(recDate.getFullYear()+''+recMonth+''+recDay)
									if ((nowVal - recVal)>=1) {
										this.recToShow = this.lastRec;
									} else {
										this.recToShow = this.lastRec-1;
									}									
									//if ((this.today - lastRecDate) > 86400000) {
									//	this.recToShow = this.lastRec;
									//} else {
									//	this.recToShow = this.lastRec-1;
									//}
								}
							}
						)
					}
				)
				//		}
				//	} else {
				//		console.log(err);
				//	}
				//});
				
			}
		})
	}

	toggleExpand(month){
		this.sectorExpand[month] *= -1;
	}
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/member/spritjoy.component.ts